<template>
    <client-page>
        <template v-slot:subHead>
            <sub-visual sh="Product" tabActive="Novelty Line" bg="/images/sub/visual/sv-product.jpg" />
        </template>

        <sub-section class="page-section--first page-section--last">
            <sub-product tit="Novelty Line" file="novelty">
                Special finished velvet with burn out & novelty printing. Jacquard &
                Emboss fabric with various patterns. Delicate flocking mesh with
                luxurious printing. Our R&D handles these items very skillfully. You
                can meet special items that you can't find anywhere else.
            </sub-product>
        </sub-section>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import SubSection from "@/components/client/sub/sub-section.vue";
import SubProduct from "@/components/client/sub/sub-product.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubSection,
        SubProduct,
    },
};
</script>

<style lang="scss" scoped>
</style>
